<template>
  <div>
    <v-card elevation="2" tile>
      <v-card-title style="float: left"
        >Gestión de &nbsp;
        <v-select
          v-model="listaSelect"
          :items="listas"
          :item-text="'nombre'"
          :item-value="'id'"
          attach
          label="Listas"
          return-object
        ></v-select>
      </v-card-title>
      <CButton
        color="primary"
        class="px-4"
        style="float: right"
        @click="crear()"
        :disabled="listaSelect.administrable == 0"
        ><CIcon name="cil-user" /> Nuevo</CButton
      >

      <v-card-text>
        <filters
          :campos="filterFields"
          :itemsKeys="{
            text: 'name',
            value: 'id',
          }"
          :eventName="'fetchItemsEvent'"
        ></filters>
        <div class="text-center" v-if="loading">
          <div class="spinner-border" role="status"></div>
        </div>
        <CDataTable
          v-if="!loading"
          hover
          striped
          :items="items"
          :fields="fields"
          :items-per-page="50"
          :active-page="activePage"
          :pagination="{ doubleArrows: false, align: 'center' }"
          @page-change="pageChange"
        >
          <template #activo="data">
            <td>
              <CBadge :color="data.item.activo?'success':'secondary'">
                {{ data.item.activo==1?'Habilitado':'Inhabilitado' }}
              </CBadge>
            </td>
          </template>
          <template #acciones="data">
            <td>
              <CLink
                v-if="data.item.editable && listaSelect.administrable == 1"
                href="#"
                @click="editar(data.item)"
                class="card-header-action btn-setting"
                v-c-tooltip.hover.click="'Editar'"
              >
                <CIcon name="cil-pencil" />
              </CLink>
            </td>
          </template>
        </CDataTable>
      </v-card-text>
    </v-card>
    <br /><br />
  </div>
</template>

<script>
import Filters from "@/components/filters";
import UserService from "@/services/user.service";
import DominioService from "@/services/dominio.service";
import ListaService from "@/services/lista.service";
import { mapState } from "vuex";
import EventBus from "@/common/EventBus";

export default {
  name: "Users",
  data() {
    return {
      //items: usersData,
      items: [],
      fields: [
        { key: "id", label: "Código" },
        { key: "valor_texto", label: "Nombre", _classes: "font-weight-bold" },
        { key: "activo", label: "Estado" },
        { key: "acciones", label: "Acciones" },
      ],
      filterFields: [
        { value: "name", label: "Nombre" },
        {
          value: "active",
          label: "Estado",
          options: [
            { id: 1, name: "Habilitado" },
            { id: 0, name: "Inhabilitado" },
          ],
        },
      ],
      listas: [
        
      ],
      listaSelect: {
        id: undefined
      },
      activePage: 1,
      loading: false,
      message: "",
    };
  },
  components: {
    Filters,
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page);
        }
      },
    },
    listaSelect(val) {
      //this.fetchItems('')
      this.items = this.listaSelect.opciones
      console.log(this.listaSelect.administrable)
    }
  },
  computed: {
    ...mapState(["permissions"]),
  },
  mounted() {
    if (!this.permissions.includes("Gestión de Usuarios"))
      this.$router.push("/dashboard");
    this.fetchDominios('')

    if (localStorage.getItem("lista_select")) {
      this.listaSelect = JSON.parse(localStorage.getItem("lista_select"))
    }

    EventBus.on("fetchItemsEvent", (cadenaBusqueda) => {
      this.fetchItems(cadenaBusqueda);
    });
  },
  methods: {
    fetchDominios(cadenaBusqueda) {
      this.loading = true;
      DominioService.getItems(cadenaBusqueda).then(
        (response) => {
          this.listas = response.data;
          console.log(response.data);
          this.loading = false;
        },
        (error) => {
          this.content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          this.loading = false;
        }
      );
    },
    /*fetchItems(cadenaBusqueda) {
      this.loading = true;
      ListaService.getItems(this.listaSelect.id, cadenaBusqueda).then(
        (response) => {
          this.items = response.data;
          console.log(response.data);
          this.loading = false;
        },
        (error) => {
          this.content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          this.loading = false;
        }
      );
    },*/
    crear() {
      localStorage.setItem("lista_select", JSON.stringify(this.listaSelect))
      localStorage.removeItem("datos_lista")
      this.$router.push({ path: `listas/editar` })
    },
    editar(item) {
      localStorage.setItem("lista_select", JSON.stringify(this.listaSelect))
      localStorage.setItem("datos_lista", JSON.stringify(item))
      this.$router.push({ path: `listas/editar` })
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } })
    },
  },
};
</script>
